// extracted by mini-css-extract-plugin
export var closeButton = "_65-0";